<template>
<m-pageframe
    title="Password Reset Links"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >

        <template v-slot:item.creation_time="{ item }">
            {{$rc.pretty(item.creation_time, 'date')}}
        </template>

        <template v-slot:item.expiration_time="{ item }">
            {{$rc.pretty(item.expiration_time, 'date')}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickDelete(item)"
                >
                    <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    </v-data-table>

    <p
        style="margin-top: 15px"
    >
        <b>Note:</b> Password reset links are deleted when used. They can only be used <b>one</b> time.
    </p>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Organization', value: 'organization_label'},
                { text: 'Username', value: 'employee_username'},
                { text: 'Name', value: 'employee_label'},
                { text: 'Created', value: 'creation_time'},
                { text: 'Expires', value: 'expiration_time'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/admin/password-reset-links',
            
                'params' :
                {
                    'full_text': this.full_text,
                },
            
                'on_success': (data) =>
                {
                    this.results = data.results;
                },
            
                'on_error': 'Unable to list password reset links',
            });
        },
        
        onClickDelete(item)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'DELETE: /api/v1/admin/password-reset-links/for-employee/:employee_id',
            
                'params' :
                {
                    'employee_id': item.employee_id,
                },
            
                'on_success': (data) =>
                {
                    this.doUpdate();
                },
            
                'on_error': 'Unable to delete password reset link',
            });
        },
    },

    computed: {
    }
}
</script>

<style lang="scss" scoped>
</style>